import styled, { css } from 'foundations-theming-specialty/utils';
import { NEW_GLOBAL_TOOLBAR_HEIGHT } from './constants';
import { Z_INDEX_GLOBAL_TOOLBAR_HEADER } from '../../constants/z_index';
import { useCallback } from 'react';
import { updateRootnavComponentDimension } from '../../NavLayoutDimensions/utils/updateRootnavComponentDimension';
import setRootStyleProperty from '../../utils/setRootStyleProperty';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { useIsBranchPreviewEnabled } from '../../hooks/useIsBranchPreviewEnabled';
import { selectNavType } from '../../selectors';
import { jsx as _jsx } from "react/jsx-runtime";
const branchPreviewStyles = css(["border-image:repeating-linear-gradient( 10deg,#ff7a59,#ff7a59 3px,#fff1ee 3px,#fff1ee 6px ) 1 !important;background:rgb(59,103,158) !important;background:linear-gradient( to bottom,rgba(59,103,158,1) 0%,rgba(43,136,217,1) 50%,rgba(32,124,202,1) 51%,rgba(125,185,232,1) 100% ) !important;"]);
const StyledHeader = styled.header.withConfig({
  displayName: "GlobalToolbarHeader__StyledHeader",
  componentId: "sc-1swm89y-0"
})(({
  isHubless,
  isBranchPreview,
  theme
}) => {
  return css(["background-color:", ";height:", ";display:flex !important;justify-content:space-between;padding:", ";", ""], theme.color['global-shell-fill-surface-default'], NEW_GLOBAL_TOOLBAR_HEIGHT, isHubless ? '0 24px 0 32px !important' : '0 12px !important', isBranchPreview && branchPreviewStyles);
});
export function GlobalToolbarHeader({
  children
}) {
  const dispatch = useAppDispatch();
  const navType = useAppSelector(selectNavType);
  const isBranchPreview = useIsBranchPreviewEnabled();
  const setToolbarRef = useCallback(el => {
    const height = el ? el.getBoundingClientRect().height : 0;
    updateRootnavComponentDimension('GlobalToolbar', {
      height
    }, dispatch);
    setRootStyleProperty('--global-nav-toolbar-zIndex', `${Z_INDEX_GLOBAL_TOOLBAR_HEADER}`);
  }, [dispatch]);
  return /*#__PURE__*/_jsx(StyledHeader, {
    ref: setToolbarRef,
    id: "hs-global-toolbar",
    "data-test-id": "hs-global-toolbar",
    "data-nav-type": navType,
    isBranchPreview: isBranchPreview,
    isHubless: false,
    children: children
  });
}